import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const ChapterLabel = ({ number, title }) => (
  <div className="flex items-center gap-4 mb-8" data-testid={`chapter-${number}`}>
    <span className="font-sans text-xs tracking-[0.25em] text-brass font-semibold">{number}</span>
    <span className="h-px w-12 bg-brass/60" />
    <span className="font-sans text-xs tracking-[0.25em] uppercase text-muted-foreground font-medium">{title}</span>
  </div>
);
